import { useMutation } from "react-query";
import API from "../../Config/axios";

const onUpdateQueueConfigurationById = async (id, payload) => {
  const { data } = await API.put(`/queue_configurations/${id}`, payload);
  return data;
};

const useUpdateQueueConfigurationById = () => {
  return useMutation(({ id, payload }) =>
    onUpdateQueueConfigurationById(id, payload)
  );
};

export default useUpdateQueueConfigurationById;
